import { request } from '@/shared/api/request'
export const downloadFileByUid = (fileGuid) =>
	request({
		url: `/file/s3/download/${fileGuid}`,
		method: 'GET',
		responseType: 'blob',
	})
